// Import the functions you need from the SDKs you need
import { initializeApp, getApp, getApps } from 'firebase/app'

const firebaseConfig =  {
  apiKey: "AIzaSyBI5Q6LqUU2CLZrnpS1i7SrI5p8gcgdyYo",
  authDomain: "medarc-569e7.firebaseapp.com",
  databaseURL: "https://medarc-569e7-default-rtdb.firebaseio.com",
  projectId: "medarc-569e7",
  storageBucket: "medarc-569e7.appspot.com",
  messagingSenderId: "745046050494",
  appId: "1:745046050494:web:13674ece75ad3e6f5b80ef",
  measurementId: "G-6W2G1P8PP8"
  };


// Initialize Firebase
const firebaseApp = !getApps().length ? initializeApp(firebaseConfig) : getApp();


export {
    firebaseApp
}